export default __webpack_public_path__ + "static/media/soundtracker.910272fc.png";